import { useMultiStepFormContext } from "#src/hooks/useMultiStepForm";
import {
  Form,
  Panel,
  TextAreaInput,
  useForm,
} from "@validereinc/common-components";
import { MAX_WORKER_VERSION_DESCRIPTION_LENGTH } from "@validereinc/domain";
import classNames from "classnames/bind";
import React, { useEffect } from "react";
import styles from "./CreateWorkerVersionFormPanels.module.scss";

const cx = classNames.bind(styles);

type DescriptionFormValues = {
  description?: string;
};

const WorkerVersionDescriptionFormStep = ({
  stepNumber,
}: {
  stepNumber: number;
}) => {
  const { currentStep, updateStep } = useMultiStepFormContext();
  const form = useForm<DescriptionFormValues>({
    defaultValues: {
      description: "",
    },
  });

  const getDescriptionValue = () => form.getValues().description ?? "";

  useEffect(() => {
    updateStep(stepNumber, {
      getValues: () => ({ description: getDescriptionValue() }),
      getSubmitHandler: (setValues) => () => {
        setValues({ description: getDescriptionValue() });
        return Promise.resolve();
      },
      getFormState: () => ({
        isSubmitting: false,
        isValid: true,
      }),
    });
  }, [stepNumber]);

  if (currentStep !== stepNumber) return null;

  return (
    <Panel className={cx("panel")}>
      <Form
        {...form}
        className={cx("form")}
      >
        <h4 className={cx("section-title")}>Description</h4>
        <TextAreaInput
          name="description"
          label="Version description"
          placeholder="Describe this worker version. Markdown is supported."
          isFluid
          maxLength={MAX_WORKER_VERSION_DESCRIPTION_LENGTH}
          rules={{
            validate: {
              maxLength: (value) =>
                (value?.length ?? 0) <= MAX_WORKER_VERSION_DESCRIPTION_LENGTH ||
                `Description must be less than or equal to ${MAX_WORKER_VERSION_DESCRIPTION_LENGTH} characters.`,
            },
          }}
        />
      </Form>
    </Panel>
  );
};

export default WorkerVersionDescriptionFormStep;
